import ReviewDefault from "../components/Administration/Default";
import Payments from "../components/Administration/Payments";
import EditorialTeam from "../components/Administration/EditorialTeam";
import UsersList from "../components/Administration/UserManagement/UsersList";
import AuthorsList from "../components/Administration/UserManagement/AuthorsList";
import CreateAccount from "../components/Administration/UserManagement/CreateAccount";
import ManuscriptReviewers from "../components/Administration/Reviewers";

const routes = [
  {
    path: "/administration",
    component: ReviewDefault,
    redirect: "/reviews/invitations",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "payments",
        name: "manuscriptPayments",
        component: Payments,
        meta: {
          requiresAuth: true,
          description: "Payments",
        },
      },
      {
        path: "reviewers",
        name: "manuscriptReviewers",
        component: ManuscriptReviewers,
        meta: {
          requiresAuth: true,
          description: "Manuscript reviewers",
        },
      },
      {
        path: "editorial",
        name: "editorialTeam",
        component: EditorialTeam,
        meta: {
          requiresAuth: true,
          description: "Editorial team",
        },
      },
      {
        path: "users",
        name: "userManagement",
        component: UsersList,
        meta: {
          requiresAuth: true,
          description: "Registered users management",
        },
      },
      {
        path: "authors",
        name: "authorsManagement",
        component: AuthorsList,
        meta: {
          requiresAuth: true,
          description: "Authors on the system",
        },
      },
      {
        path: "register",
        name: "createAccount",
        component: CreateAccount,
        meta: {
          requiresAuth: true,
          description: "Register new account",
        },
      },
    ],
  },
];

export default routes;
